import {BaseTerms} from "../../infrastructure/models/base-terms";

export class CompetitionsSliderWidgetTerms extends BaseTerms {
  WIDGET_ODDS_BY = "Odds by";
  WEB_TOPGAMES_SEE_ALL_WIDGET = 'Top Games';
  SLIDER_WIDGET_EMPTY_STATE = 'No games available for this competition';
}
